<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import { debounce } from '@/utils';
import Resource from '@/api/resource';

const dashboardResource = new Resource('dashboard');
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
    autoResize: {
      type: Boolean,
      default: true,
    }, /*
    chartData: {
      type: Object,
      required: true,
    }, */
    selectedYear: {
      type: Number,
      required: false,
      default: null,
    },
    selectedSpecie: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
      sidebarElm: null,
      series: [],
      query: {
        year: null,
        specie_id: null, // Nouveau paramètre pour filtrer par espèce
      },
      speciesList: [],
      chartData: {
        diseaseLabels: [],
        stats: {},
      },
    };
  },
  watch: {
    selectedYear(newYear) {
      if (newYear) {
        this.query.year = newYear;
        this.reloadChart();
      }
    },
    selectedSpecie(newSpecie) {
      if (newSpecie) {
        this.query.specie_id = newSpecie;
        this.reloadChart();
      }
    },
    /* chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    }, */
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHandler);
    }

    // Monitor the sidebar changes
    this.sidebarElm = document.getElementsByClassName('sidebar-container')[0];
    this.sidebarElm &&
      this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler);
    }

    this.sidebarElm &&
      this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler);

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.__resizeHandler();
      }
    },
    setOptions({ diseaseLabels, stats } = {}) {
      const months = this.getMonths();
      const series = diseaseLabels.map((disease) => {
        const data = Array(12).fill(0); // Initialize data for 12 months
        if (stats[disease]) {
          stats[disease].forEach(({ month, total_sick }) => {
            data[month - 1] = parseInt(total_sick, 10); // Populate data for the corresponding month
          });
        }
        return {
          name: disease,
          type: 'line',
          smooth: true,
          data,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 2,
              },
            },
          },
        };
      });

      this.chart.setOption({
        xAxis: {
          data: months,
          boundaryGap: false,
          axisTick: {
            show: false,
          },
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
          padding: [5, 10],
        },
        yAxis: {
          axisTick: {
            show: false,
          },
        },
        legend: {
          data: diseaseLabels,
        },
        series,
      });
    },
    async initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      const result = await dashboardResource.sublist('/sick-animals-per-disease-and-month-stats', this.query);
      const linesChartData = result.data;
      this.chartData = {
        diseaseLabels: linesChartData.diseaseLabels,
        stats: linesChartData.stats,
      };
      this.setOptions(linesChartData);
    },

    getMonths() {
      const months = [];
      for (let i = 1; i <= 12; i++) {
        months.push(this.$t(`dashboard.months.${i}`));
      }
      return months;
    },

    // Méthode pour recharger le graphique avec les nouveaux filtres
    async reloadChart() {
      this.chart.clear();
      this.chartData = {
        diseaseLabels: [],
        stats: {},
      };
      await this.initChart();
    },
  },
};
</script>
